
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("eb6L0", function(module, exports) {
"use strict";
var $a5275598acca5db0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ArrowCircleRight = void 0;

const $a5275598acca5db0$var$react_1 = $a5275598acca5db0$var$__importDefault((parcelRequire("acw62")));
const $a5275598acca5db0$var$ArrowCircleRight = ({ fill: fill = "none" })=>{
    if (fill === "filled") return $a5275598acca5db0$var$react_1.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 256 256",
        width: "100%",
        height: "100%"
    }, $a5275598acca5db0$var$react_1.default.createElement("path", {
        fill: "currentColor",
        d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm45.66,109.66-32,32a8,8,0,0,1-11.32-11.32L148.69,136H88a8,8,0,0,1,0-16h60.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,173.66,133.66Z"
    }));
    return $a5275598acca5db0$var$react_1.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        viewBox: "0 0 32 32",
        fill: "none",
        "aria-hidden": true
    }, $a5275598acca5db0$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        d: "M16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5ZM3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16Z",
        fill: "currentColor"
    }), $a5275598acca5db0$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        d: "M16.0553 11.0556C16.4459 10.6651 17.079 10.6651 17.4696 11.0556L21.7071 15.2931C22.0976 15.6836 22.0976 16.3168 21.7071 16.7073L17.4696 20.9448C17.079 21.3353 16.4459 21.3353 16.0553 20.9448C15.6648 20.5543 15.6648 19.9211 16.0553 19.5306L19.5857 16.0002L16.0553 12.4698C15.6648 12.0793 15.6648 11.4461 16.0553 11.0556Z",
        fill: "currentColor"
    }), $a5275598acca5db0$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        d: "M10 16C10 15.4477 10.4477 15 11 15H21C21.5523 15 22 15.4477 22 16C22 16.5523 21.5523 17 21 17H11C10.4477 17 10 16.5523 10 16Z",
        fill: "currentColor"
    }));
};
module.exports.ArrowCircleRight = $a5275598acca5db0$var$ArrowCircleRight;

});


//# sourceMappingURL=arrow-circle-right.f121f465.js.map
